__turbopack_context__.v({
  "checkboxes": "styles-module-scss-module__HkImbq__checkboxes",
  "error": "styles-module-scss-module__HkImbq__error",
  "form": "styles-module-scss-module__HkImbq__form",
  "formButton": "styles-module-scss-module__HkImbq__formButton",
  "formField": "styles-module-scss-module__HkImbq__formField",
  "form__header": "styles-module-scss-module__HkImbq__form__header",
  "form__headerLeft": "styles-module-scss-module__HkImbq__form__headerLeft",
  "form__headerRight": "styles-module-scss-module__HkImbq__form__headerRight",
  "form__title": "styles-module-scss-module__HkImbq__form__title",
  "image": "styles-module-scss-module__HkImbq__image",
  "name": "styles-module-scss-module__HkImbq__name",
  "oldprice": "styles-module-scss-module__HkImbq__oldprice",
  "price": "styles-module-scss-module__HkImbq__price",
  "stock": "styles-module-scss-module__HkImbq__stock",
});
